(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('is-root-' + sectionId);
    if (!root || root.dataset.dsInit) return;
    root.dataset.dsInit = '1';

    const dataEl = document.getElementById('is-product-data-' + sectionId);
    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    // ---- config ----
    const SHAPES = {
      rectangle: { label:'Rectangle' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true },
      bands:  { label:'Top & Bottom Bands', needsColor:true },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = { acrylic: { label:'Acrylic', engrave:'#241D0F' } };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 },
      script:{ label:'Script',        family:"'Snell Roundhand', 'Brush Script MT', 'Segoe Script', cursive", weight:400 }
    };
    // Square-ish, matching real informational/policy signage proportions
    // (check-in times, smoke-free notices, etc.) rather than a wide bar.
    const SIZES = {
      small:  { label:'Small',  w:8,  h:8 },
      medium: { label:'Medium', w:10, h:10 },
      large:  { label:'Large',  w:12, h:12 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };
    const ICONS = {
      none:      { label:'None' },
      access:    { label:'Handicap' },
      audio:     { label:'Audio Accessible' },
      nosmoking: { label:'No Smoking' }
    };
    const DETAIL_MODES = { with:{label:'With Detail Line'}, without:{label:'Without Detail Line'} };
    const ADA_MODES = { off:{label:'Off'}, on:{label:'On'} };
    const ALIGNMENTS = { left:{label:'Left'}, center:{label:'Center'}, right:{label:'Right'} };

    // Common real hotel policy/notice signs — a starting point, not a
    // restriction: editing headline, detail, or icon switches that field to
    // manual and stops future template clicks from overwriting it.
    const TEMPLATES = {
      smokeFree:      { label:'Smoke-Free Facility',   headline:'This Hotel is 100% Smoke-Free', detail:'', icon:'nosmoking' },
      checkTimes:     { label:'Check-In / Check-Out',  headline:'Check In 3:00 PM',  detail:'Check Out 11:00 AM', icon:'none' },
      breakfast:      { label:'Complimentary Breakfast', headline:'Complimentary Breakfast', detail:'Served 6:00 AM \u2013 9:00 AM', icon:'none' },
      doorsLocked24:  { label:'Doors Locked 24 Hours', headline:'Doors Locked 24 Hours', detail:'Please use your guestroom keycard for entry', icon:'none' },
      doorsLockedPM:  { label:'Doors Locked After Hours', headline:'Doors Locked 11:00 PM \u2013 6:00 AM', detail:'Please use your guestroom keycard for entry', icon:'none' },
      washHands:      { label:'Employees Wash Hands',  headline:'Employees Must Wash Hands Before Returning to Work', detail:'', icon:'none' },
      notResponsible: { label:'Not Responsible for Items', headline:'Hotel is Not Responsible for Items Left in Room', detail:'', icon:'none' },
      managerOnDuty:  { label:'Manager On Duty',       headline:'Manager On Duty', detail:'', icon:'none' },
      ownerOperator:  { label:'Owner/Operator Disclosure', headline:'This Hotel is Independently Owned and Operated', detail:'Under a Franchise Agreement with [Brand Name]', icon:'none' },
      phoneAssist:    { label:'Phone for Assistance',  headline:'Push Button or Pick Up Phone for Assistance', detail:'', icon:'none' },
      custom:         { label:'Start From Scratch',    headline:'', detail:'', icon:'none' }
    };

    let state = {
      mode:'single',
      template:'smokeFree',
      headline:'This hotel is 100% Smoke-Free', headlineManual:false,
      detail:'', detailManual:false, detailMode:'without',
      icon:'nosmoking', iconManual:false,
      headlineAlign:'center', detailAlign:'center',
      shape:'rectangle', material:'acrylic', typeface:'sans',
      size:'medium', mounting:'flush',
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'brass', accentCustomColor:'#8C2F2A',
      adaMode:'on',
      // ---- bulk order (a property ordering several different policy/notice
      // signs in one batch — e.g. Smoke-Free + Check-In Times + Doors Locked).
      // Shape/material/typeface/mounting/size/color/accent/alignment are
      // shared across the batch; only the fields below vary per sign. ----
      bulkOrders: [],
      activeBulkIndex: 0
    };
    let lastTemplate = state.template;

    // Fields that belong to a specific sign in the batch, not the shared
    // style — saved into / loaded from state.bulkOrders[i] whenever the
    // active row changes, so the existing single-sign editor fields keep
    // working unmodified, always editing "whichever row is active."
    const PER_ROW_FIELDS = ['template','headline','headlineManual','detail','detailManual','detailMode','icon','iconManual'];
    function makeRowFromTemplate(templateKey){
      const t = TEMPLATES[templateKey];
      return {
        template: templateKey,
        headline: t.headline, headlineManual:false,
        detail: t.detail, detailManual:false, detailMode: t.detail ? 'with' : 'without',
        icon: t.icon, iconManual:false,
        quantity: 1
      };
    }
    function saveActiveRowFromState(){
      const row = state.bulkOrders[state.activeBulkIndex];
      if (!row) return;
      PER_ROW_FIELDS.forEach(f=>{ row[f] = state[f]; });
    }
    function loadRowIntoState(row){
      PER_ROW_FIELDS.forEach(f=>{ state[f] = row[f]; });
      lastTemplate = state.template; // row's content is already resolved — don't let the auto-suggest effect override it this render
    }
    function switchBulkRow(newIndex){
      if (state.bulkOrders[state.activeBulkIndex]) saveActiveRowFromState();
      state.activeBulkIndex = newIndex;
      const row = state.bulkOrders[newIndex];
      if (row) loadRowIntoState(row);
      render();
    }

    const variantMap = {};
    productData.variants.forEach(v=>{ variantMap[v.size + '|' + v.material + '|' + v.mounting] = v; });
    function findVariant(){
      const key = SIZES[state.size].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }
    // Same variant per row here (unlike Rules & Regulations) since every
    // Informational size is a square scale variant, not a different aspect
    // ratio — size is a shared batch setting, so one lookup covers all rows.
    function computeBulkTotal(){
      let total = 0, prefix = '$', anyMissing = false, validCount = 0;
      const v = findVariant();
      state.bulkOrders.forEach(row=>{
        if (!row.headline || !row.headline.trim()) return;
        if (!row.quantity || row.quantity < 1) return;
        if (!v || !v.available){ anyMissing = true; return; }
        const m = String(v.price).match(/^([^\d]*)([\d,.]+)/);
        if (m){
          prefix = m[1] || prefix;
          total += (parseFloat(m[2].replace(/,/g,'')) || 0) * row.quantity;
        }
        validCount += row.quantity;
      });
      return { total, prefix, anyMissing, validCount };
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    // Full icon set reused verbatim from the Room Number / Common Room
    // builders' real vector art (not simplified stroke icons).
    function iconPath(id, color){
      const stroke = `stroke="${color}" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"`;
      switch(id){
        case 'access': return `<g transform="scale(0.08)"><path d="M 173.101562 109.238281 C 189.375 107.734375 202.019531 93.714844 202.019531 77.316406 C 202.019531 59.667969 187.617188 45.269531 169.972656 45.269531 C 152.324219 45.269531 137.925781 59.667969 137.925781 77.316406 C 137.925781 82.699219 139.425781 88.207031 141.929688 92.839844 L 153.347656 253.511719 L 270.953125 253.546875 L 319.1875 366.566406 L 382.515625 341.730469 L 372.710938 318.378906 L 337.269531 331.171875 L 290.597656 223.425781 L 181.253906 224.160156 L 179.753906 203.8125 L 258.90625 203.84375 L 258.90625 173.738281 L 176.734375 173.703125 L 173.105469 109.234375 Z" fill="${color}"/><path d="M 291.375 339.664062 C 271.527344 378.898438 229.984375 404.75 185.671875 404.75 C 120.585938 404.75 67.5 351.664062 67.5 286.578125 C 67.5 240.878906 95.195312 198.414062 136.523438 179.589844 L 139.199219 214.488281 C 114.753906 229.894531 99.683594 257.6875 99.683594 286.820312 C 99.683594 334.035156 138.195312 372.542969 185.410156 372.542969 C 228.605469 372.542969 265.4375 339.394531 270.464844 296.863281 L 291.378906 339.660156 Z" fill="${color}"/></g>`;
        case 'audio': return `<g transform="scale(0.049150)"><g transform="translate(-33.552374,765.800857) scale(0.100000,-0.100000)"
fill="${color}" stroke="none">
<path d="M6235 7647 c-140 -46 -235 -176 -235 -320 0 -84 30 -144 133 -270
212 -260 355 -482 491 -762 286 -585 413 -1203 373 -1810 -17 -269 -15 -320
18 -394 32 -71 96 -135 170 -171 138 -67 329 3 407 147 34 63 45 123 59 323
23 326 0 748 -60 1080 -130 716 -450 1397 -934 1990 -85 104 -118 134 -182
167 -60 31 -176 41 -240 20z"/>
<path d="M3085 6990 c-139 -17 -269 -42 -373 -71 -388 -109 -731 -309 -1013
-589 -298 -297 -496 -630 -614 -1035 -44 -150 -23 -254 71 -355 65 -69 139
-103 229 -104 105 -1 167 24 241 98 60 60 62 63 108 206 89 278 215 489 411
686 252 253 523 405 850 475 156 33 431 38 594 10 343 -58 648 -218 901 -471
153 -153 239 -271 330 -455 124 -252 165 -427 165 -710 -1 -214 -13 -296 -72
-480 -148 -463 -468 -834 -888 -1030 -219 -103 -264 -126 -355 -186 -123 -81
-324 -281 -402 -399 -175 -265 -249 -495 -267 -835 -6 -93 -17 -197 -26 -229
-59 -222 -233 -404 -460 -482 -67 -23 -97 -28 -185 -28 -166 0 -292 44 -427
150 -102 80 -139 98 -203 98 -74 -1 -146 -39 -233 -122 -88 -86 -122 -153
-121 -242 1 -118 48 -185 212 -303 195 -140 428 -224 685 -247 254 -22 524 46
764 193 287 175 487 426 588 739 45 139 62 240 70 418 7 168 25 267 66 364 58
136 168 270 285 347 34 21 125 68 203 103 332 151 505 268 747 510 320 319
523 674 628 1096 135 539 78 1074 -168 1575 -165 335 -404 625 -698 845 -319
239 -653 379 -1064 445 -115 19 -474 28 -579 15z"/>
<path d="M5565 6907 c-96 -32 -163 -91 -204 -177 -22 -46 -26 -69 -26 -140 0
-107 16 -141 119 -270 242 -300 390 -599 490 -996 56 -219 68 -328 75 -664 6
-303 7 -317 29 -358 35 -67 98 -129 161 -159 48 -24 68 -28 141 -28 74 0 92 4
143 30 73 37 139 108 168 183 20 51 23 81 27 275 7 318 -19 555 -94 858 -117
479 -364 979 -654 1328 -68 82 -151 123 -258 128 -46 2 -93 -3 -117 -10z"/>
<path d="M3025 5904 c-203 -36 -374 -105 -547 -220 -106 -71 -135 -106 -164
-205 -35 -116 0 -272 79 -351 80 -80 236 -111 348 -69 31 12 80 40 110 62 69
53 197 113 274 130 136 29 324 5 442 -55 66 -33 158 -107 210 -169 195 -232
204 -588 19 -830 -74 -97 -102 -192 -86 -289 20 -121 65 -185 169 -236 68 -33
83 -37 155 -37 95 0 145 14 207 54 120 80 275 383 325 638 24 119 24 375 1
492 -37 182 -105 349 -202 496 -214 323 -559 541 -939 594 -105 15 -303 12
-401 -5z"/>
<path d="M3257 4990 c-104 -27 -179 -89 -226 -190 -37 -78 -37 -191 0 -270 78
-167 272 -241 434 -167 78 36 137 95 170 170 73 162 0 360 -160 433 -60 28
-159 38 -218 24z"/>
<path d="M2570 4317 c-57 -17 -141 -79 -177 -131 -97 -141 -69 -336 65 -441
69 -55 126 -75 208 -75 262 0 422 295 279 512 -36 53 -118 115 -177 133 -58
17 -146 18 -198 2z"/>
<path d="M1553 3979 c-71 -27 -155 -106 -190 -177 -23 -47 -28 -70 -28 -132 0
-139 8 -149 437 -577 435 -433 429 -428 576 -421 103 5 133 19 213 95 76 72
103 133 103 233 0 133 4 127 -437 567 -365 364 -396 392 -450 412 -73 27 -155
27 -224 0z"/>
<path d="M1257 2990 c-104 -27 -179 -89 -226 -190 -37 -78 -37 -191 0 -270 78
-167 272 -241 434 -167 78 36 137 95 170 170 73 162 0 360 -160 433 -60 28
-159 38 -218 24z"/>
<path d="M570 2317 c-57 -17 -141 -79 -177 -131 -97 -141 -69 -336 65 -441 69
-55 126 -75 208 -75 262 0 422 295 279 512 -36 53 -118 115 -177 133 -58 17
-146 18 -198 2z"/>
</g></g>`;
        case 'nosmoking': return `<g transform="scale(0.043760)"><g transform="translate(-2.171468,825.530283) scale(0.100000,-0.100000)"
fill="${color}" stroke="none">
<path d="M3795 8250 c-727 -55 -1490 -333 -2090 -764 -255 -183 -635 -542
-816 -771 -506 -639 -799 -1403 -860 -2240 -15 -206 -6 -688 16 -845 176
-1288 878 -2374 1954 -3025 888 -537 1947 -718 2967 -506 621 128 1141 363
1653 746 617 461 1074 1083 1361 1853 200 534 297 1171 261 1706 -59 875 -360
1665 -887 2326 -141 176 -472 508 -644 645 -600 477 -1361 785 -2135 866 -137
14 -633 20 -780 9z m614 -631 c500 -48 889 -159 1296 -368 354 -182 595 -354
869 -621 508 -495 834 -1107 980 -1840 44 -220 56 -348 56 -596 0 -618 -120
-1126 -383 -1624 -80 -153 -164 -293 -246 -409 -107 -155 -135 -191 -148 -188
-7 1 -329 317 -716 702 -2578 2567 -4032 4011 -4048 4023 -34 24 -128 142
-123 155 7 19 133 114 259 194 534 341 981 500 1595 567 157 17 457 19 609 5z
m-2203 -1948 c1865 -1852 4169 -4158 4169 -4173 0 -21 -154 -142 -315 -250
-267 -177 -518 -300 -821 -402 -634 -213 -1293 -243 -1934 -86 -274 67 -481
143 -727 266 -683 342 -1216 879 -1563 1573 -346 694 -449 1515 -284 2271 54
244 104 404 202 640 115 277 216 444 502 831 17 24 36 39 46 37 9 -2 336 -320
725 -707z"/>
<path d="M3745 7038 c-79 -28 -107 -89 -160 -353 -33 -158 -43 -364 -26 -485
35 -235 172 -496 332 -631 144 -121 262 -176 461 -215 49 -9 94 -22 102 -28 8
-6 26 -51 41 -101 33 -111 80 -214 132 -291 97 -143 293 -285 488 -353 l100
-35 325 -7 c206 -4 340 -11 365 -19 23 -7 57 -30 81 -55 52 -53 64 -103 64
-255 0 -98 2 -110 19 -120 11 -5 73 -10 139 -10 167 0 168 0 165 155 -3 202
-49 323 -167 440 -40 39 -98 84 -131 102 -120 63 -133 65 -455 69 -339 5 -393
13 -520 75 -145 72 -265 212 -310 364 -6 22 -15 90 -20 150 -9 124 -20 157
-59 175 -14 7 -84 16 -156 21 -71 5 -165 17 -208 28 -234 61 -398 233 -466
494 -44 167 -38 310 25 602 41 193 43 239 12 259 -17 11 -138 41 -142 35 -1 0
-14 -5 -31 -11z"/>
<path d="M4559 6609 c-19 -19 -21 -30 -18 -134 3 -75 8 -117 18 -128 11 -14
33 -17 120 -17 285 0 451 -51 575 -176 92 -94 126 -171 126 -288 0 -100 -23
-177 -80 -273 -28 -45 -50 -91 -50 -101 0 -24 46 -87 93 -129 45 -39 94 -48
231 -39 131 8 335 -8 406 -32 176 -61 344 -186 436 -323 106 -160 125 -240
133 -581 8 -316 2 -301 114 -306 83 -4 149 10 178 39 18 18 19 34 19 227 0
224 -12 327 -57 482 -75 262 -256 503 -474 634 -186 110 -335 156 -536 163
-79 3 -143 8 -143 10 0 3 7 33 17 67 22 81 22 241 0 325 -36 136 -136 289
-251 383 -194 159 -378 217 -693 218 -132 0 -145 -2 -164 -21z"/>
<path d="M5103 3954 c-7 -19 56 -88 227 -249 41 -38 163 -155 270 -260 273
-266 349 -332 361 -314 14 23 12 812 -3 827 -9 9 -118 12 -430 12 -372 0 -419
-2 -425 -16z"/>
<path d="M6130 3900 c-19 -19 -20 -33 -20 -422 0 -222 4 -409 8 -416 7 -9 45
-12 158 -10 l149 3 3 407 c1 249 -2 416 -8 432 l-10 26 -130 0 c-117 0 -132
-2 -150 -20z"/>
<path d="M6590 3901 c-6 -13 -10 -165 -10 -425 0 -390 1 -406 19 -416 33 -17
243 -13 269 6 l22 15 0 386 0 385 -34 34 -34 34 -111 0 c-99 0 -111 -2 -121
-19z"/>
<path d="M1501 3960 c-69 -17 -66 5 -69 -465 -3 -417 -2 -425 18 -445 l20 -20
1505 2 c1196 2 1507 6 1517 16 10 10 -4 29 -72 98 -47 47 -139 136 -205 197
-103 95 -205 191 -565 534 -36 34 -79 68 -95 75 -24 10 -229 13 -1025 15 -547
1 -1010 -2 -1029 -7z"/>
</g></g>`;
        default: return '';
      }
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.16;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      const b = w*0.05;
      return `M ${x+b} ${y} Q ${x-w*0.025} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 8 : rx;
      switch(shape){
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      const inset = (shape==='rectangle') ? 20 : Math.max(w,h)*0.07;
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      return shapeMarkup(shape, px+w*0.03, py+h*0.06, w, h, `fill="${color}"`, 8);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe': return `<rect x="${px}" y="${py}" width="${w*0.1}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.14;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/><rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split': return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.62},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.08, y1 = py+h*0.2;
          return `<path d="M ${px} ${y0+h*0.03} C ${px+w*0.3} ${y0-h*0.04}, ${px+w*0.7} ${y0+h*0.05}, ${px+w} ${y0-h*0.01}
                   L ${px+w} ${y1-h*0.01} C ${px+w*0.7} ${y1+h*0.05}, ${px+w*0.3} ${y1-h*0.04}, ${px} ${y1+h*0.03} Z"
                   fill="${color}" opacity="0.9"/>`;
        }
        default: return '';
      }
    }
    function materialFillDefs(uid, customColor){
      const c = customColor || '#2B2E33';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    // ---- WCAG contrast ratio — still the relevant check for directional
    // signs (§703.5.7 requires high contrast), unlike braille/raised chars
    // which don't apply to this sign type at all ----
    function hexToRgb(hex){
      hex = String(hex).replace('#','');
      if (hex.length===3) hex = hex.split('').map(c=>c+c).join('');
      const num = parseInt(hex,16);
      return [(num>>16)&255, (num>>8)&255, num&255];
    }
    function relLuminance(hex){
      const [r,g,b] = hexToRgb(hex).map(v=>{ v/=255; return v<=0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055,2.4); });
      return 0.2126*r+0.7152*g+0.0722*b;
    }
    function contrastRatio(hex1,hex2){
      const L1=relLuminance(hex1), L2=relLuminance(hex2);
      return (Math.max(L1,L2)+0.05)/(Math.min(L1,L2)+0.05);
    }

    function buildChipRow(container, options, key, disableFn, onSelect){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          if (onSelect) onSelect(k);
          render();
        });
        container.appendChild(btn);
      });
    }

    // Keeps "3:00" and "PM" from wrapping onto separate lines.
    function tokenize(text){
      const raw = String(text||'').split(/\s+/).filter(Boolean);
      const merged = [];
      raw.forEach(w=>{
        if (/^(AM|PM|am|pm)$/.test(w) && merged.length){
          merged[merged.length-1] += ' ' + w;
        } else {
          merged.push(w);
        }
      });
      return merged;
    }

    // ---- real text measurement (not a char-count estimate — that pattern
    // caused real overflow bugs on other signs in this family once templates
    // introduced genuinely long phrases like "Hotel is Not Responsible for
    // Items Left in Room") ----
    const measureSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    measureSvg.setAttribute('style','position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;');
    const measureText = document.createElementNS('http://www.w3.org/2000/svg','text');
    measureSvg.appendChild(measureText);
    document.body.appendChild(measureSvg);
    function measureTextWidth(text, fontSize, family, weight){
      measureText.setAttribute('font-size', fontSize);
      measureText.setAttribute('font-family', family);
      measureText.setAttribute('font-weight', weight);
      measureText.textContent = text;
      return measureText.getComputedTextLength();
    }
    function wrapTextMeasured(text, maxWidth, fontSize, family, weight){
      const words = tokenize(text);
      if (!words.length) return [];
      const lines = [];
      let current = '';
      words.forEach(word=>{
        const test = current ? current+' '+word : word;
        if (current && measureTextWidth(test, fontSize, family, weight) > maxWidth){
          lines.push(current);
          current = word;
        } else {
          current = test;
        }
      });
      if (current) lines.push(current);
      return lines;
    }
    function fitWrappedTextMeasured(text, maxWidth, maxHeight, maxFontSize, minFontSize, family, weight, lineHeightMult){
      let fontSize = maxFontSize;
      let lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
      while (fontSize > minFontSize){
        lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
        const neededHeight = lines.length * fontSize * lineHeightMult;
        // Wrapping alone doesn't guarantee every line actually fits —  a
        // single long word (e.g. "Complimentary") can still be wider than
        // maxWidth on its own line, since word-wrap can't split a word. Only
        // checking height let that slip through and clip against the plate
        // edge. Re-measure the widest wrapped line for real, every pass.
        const widestLineWidth = Math.max(0, ...lines.map(l=>measureTextWidth(l, fontSize, family, weight)));
        if (neededHeight <= maxHeight && widestLineWidth <= maxWidth) break;
        fontSize -= 1;
      }
      lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
      return { fontSize, lines };
    }

    function bindTextInputs(){
      const headlineEl = root.querySelector('#is-headline');
      if (headlineEl){
        headlineEl.value = state.headline;
        headlineEl.addEventListener('input', e=>{
          state.headline = e.target.value;
          state.headlineManual = true;
          render();
        });
      }
      const detailEl = root.querySelector('#is-detail');
      if (detailEl){
        detailEl.value = state.detail;
        detailEl.addEventListener('input', e=>{
          state.detail = e.target.value;
          state.detailManual = true;
          render();
        });
      }
      const plateEl = root.querySelector('#is-plateColor');
      if (plateEl){
        plateEl.value = state.plateColor;
        plateEl.addEventListener('input', e=>{ state.plateColor = e.target.value; render(); });
      }
      const accentCustomEl = root.querySelector('#is-accentCustomColor');
      if (accentCustomEl){
        accentCustomEl.value = state.accentCustomColor;
        accentCustomEl.addEventListener('input', e=>{ state.accentCustomColor = e.target.value; render(); });
      }
      const textColorEl = root.querySelector('#is-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
    }

    function buildOrdersTable(container){
      const rows = container.querySelectorAll('.is-order-row');
      if (rows.length !== state.bulkOrders.length){
        container.innerHTML = '';
        state.bulkOrders.forEach((row, i)=> container.appendChild(buildOrderRow(row, i)));
        return;
      }
      state.bulkOrders.forEach((row, i)=>{
        const el = rows[i];
        el.classList.toggle('active', i === state.activeBulkIndex);
        const titleEl = el.querySelector('.is-order-title');
        if (titleEl) titleEl.textContent = row.headline.trim() || TEMPLATES[row.template].label;
        const subtitleEl = el.querySelector('.is-order-subtitle');
        if (subtitleEl) subtitleEl.textContent = TEMPLATES[row.template].label;
        const qtyInput = el.querySelector('.is-order-qty');
        if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = row.quantity;
      });
    }

    function buildOrderRow(row, i){
      const el = document.createElement('div');
      el.className = 'is-order-row' + (i===state.activeBulkIndex ? ' active' : '');

      const info = document.createElement('button');
      info.type = 'button';
      info.className = 'is-order-info';
      info.innerHTML = `<span class="is-order-title">${escapeXml(row.headline.trim() || TEMPLATES[row.template].label)}</span><span class="is-order-subtitle">${escapeXml(TEMPLATES[row.template].label)}</span>`;
      info.addEventListener('click', ()=> switchBulkRow(i));

      const qtyInput = document.createElement('input');
      qtyInput.type = 'number'; qtyInput.className = 'is-order-qty';
      qtyInput.min = '1'; qtyInput.max = '99'; qtyInput.value = row.quantity;
      qtyInput.setAttribute('aria-label', 'Quantity');
      qtyInput.addEventListener('input', e=>{
        row.quantity = Math.max(1, parseInt(e.target.value,10) || 1);
        render();
      });
      qtyInput.addEventListener('click', e=> e.stopPropagation());

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button'; removeBtn.className = 'is-order-remove';
      removeBtn.textContent = '\u00d7'; removeBtn.setAttribute('aria-label', 'Remove this sign');
      removeBtn.addEventListener('click', ()=>{
        state.bulkOrders.splice(i, 1);
        if (state.activeBulkIndex >= state.bulkOrders.length) state.activeBulkIndex = Math.max(0, state.bulkOrders.length-1);
        if (state.bulkOrders[state.activeBulkIndex]) loadRowIntoState(state.bulkOrders[state.activeBulkIndex]);
        render();
      });

      el.appendChild(info);
      el.appendChild(qtyInput);
      el.appendChild(removeBtn);
      return el;
    }

    function bindBulkControls(){
      const addBtn = root.querySelector('#is-bulkAddSignBtn');
      if (addBtn) addBtn.addEventListener('click', ()=>{
        const newRow = makeRowFromTemplate('smokeFree');
        state.bulkOrders.push(newRow);
        switchBulkRow(state.bulkOrders.length - 1);
      });
    }

    function render(){
      // Auto-suggest headline/detail/icon when the template changes, unless
      // the customer has typed/picked their own — must run first, before
      // anything else in render() reads state.
      if (state.template !== lastTemplate){
        const t = TEMPLATES[state.template];
        if (!state.headlineManual) state.headline = t.headline;
        if (!state.detailManual){
          state.detail = t.detail;
          state.detailMode = t.detail ? 'with' : 'without';
        }
        if (!state.iconManual) state.icon = t.icon;
        lastTemplate = state.template;
      }

      const shapeName = state.shape;
      const isAda = state.adaMode==='on';
      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 460, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'dsclip-' + sectionId;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 8)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const textColor = state.textColor;
      const plateStroke = 'rgba(255,255,255,0.55)';
      const plateShadow = shadowFilter(state.mounting);

      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const hasIcon = state.icon !== 'none';
      const hasDetail = state.detailMode==='with' && !!state.detail.trim();

      // Each non-rectangular shape curves inward differently — a flat 6%
      // margin is only safe for shapes with straight sides. Wavy pinches in
      // by ~14.4% of width at the vertical middle, and arch's dome narrows
      // above ~24% of height, so both need their own clearance.
      const SIDE_MARGIN  = { rectangle:0.06, arch:0.06, wavy:0.19, bowed:0.07, diagonal:0.06 };
      const TOP_MARGIN   = { arch:0.30 };
      const sideMargin = SIDE_MARGIN[shapeName] ?? 0.06;
      const minTopFrac = TOP_MARGIN[shapeName] || 0;

      // Side Stripe and Top & Bottom Bands carve out dedicated space — shift
      // the content area clear of them rather than drawing text on top.
      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeft = px + plateW*(hasStripe ? Math.max(0.14, sideMargin) : sideMargin);
      const contentRight = px + plateW*(1-sideMargin);
      const cx = (contentLeft+contentRight)/2;
      const usableW = (contentRight-contentLeft) * 0.92;
      const bandInset = hasBands ? plateH*0.15 : 0;
      const contentTop = py + plateH*Math.max(0.08, minTopFrac) + bandInset;
      const contentBottom = py + plateH*0.94 - bandInset;
      const usableH = contentBottom - contentTop;

      // Preset alignment (not freeform positioning) — bounded so a customer
      // can change where text sits without overlapping anything else. Center
      // gets implicit margin from usableW already being 92% of the zone, but
      // Left/Right anchor right at that zone's boundary, so they get their
      // own explicit inset too (a Rectangle plate's boundary here already
      // has the 6% SIDE_MARGIN baked in, but the extra inset keeps a second,
      // independent margin rather than relying on those two numbers to
      // always agree if either one changes later).
      const alignInset = usableW * 0.04;
      function alignX(align){
        if (align==='left') return contentLeft + alignInset;
        if (align==='right') return contentRight - alignInset;
        return cx;
      }
      function anchorFor(align){
        if (align==='left') return 'start';
        if (align==='right') return 'end';
        return 'middle';
      }

      // Zone allocation depends on which optional pieces are present — an
      // icon (centered above) and/or a divided detail line (below) — so the
      // headline always gets whatever room is actually left over rather than
      // a fixed slice that's wrong for the other three combinations.
      let iconCy, headTop, headBottom, dividerY, detailTop, detailBottom;
      if (hasIcon && hasDetail){
        iconCy = contentTop + usableH*0.14;
        headTop = contentTop + usableH*0.30; headBottom = contentTop + usableH*0.60;
        dividerY = contentTop + usableH*0.66;
        detailTop = contentTop + usableH*0.72; detailBottom = contentTop + usableH*0.90;
      } else if (hasIcon){
        iconCy = contentTop + usableH*0.16;
        headTop = contentTop + usableH*0.32; headBottom = contentTop + usableH*0.88;
      } else if (hasDetail){
        headTop = contentTop + usableH*0.08; headBottom = contentTop + usableH*0.48;
        dividerY = contentTop + usableH*0.55;
        detailTop = contentTop + usableH*0.62; detailBottom = contentTop + usableH*0.88;
      } else {
        headTop = contentTop + usableH*0.10; headBottom = contentTop + usableH*0.90;
      }

      function renderWrappedBlock(lines, fontSize, lineHeightMult, zoneTop, zoneBottom, weight, family, opacity, align){
        const totalH = lines.length * fontSize * lineHeightMult;
        const blockTop = zoneTop + Math.max(0, ((zoneBottom-zoneTop) - totalH)/2);
        const x = alignX(align);
        const anchor = anchorFor(align);
        return lines.map((line,i)=>{
          const y = blockTop + (i+0.82)*fontSize*lineHeightMult;
          return `<text x="${x}" y="${y}" text-anchor="${anchor}" font-family="${family}" font-weight="${weight}" font-size="${fontSize}" fill="${textColor}" opacity="${opacity}">${escapeXml(line)}</text>`;
        }).join('');
      }

      const headFit = fitWrappedTextMeasured(state.headline, usableW, headBottom-headTop, plateH*0.15, 10, typeface.family, typeface.weight, 1.22);
      const headlineMarkup = renderWrappedBlock(headFit.lines, headFit.fontSize, 1.22, headTop, headBottom, typeface.weight, typeface.family, 1, state.headlineAlign);

      let detailMarkup = '', dividerMarkup = '';
      if (hasDetail){
        const detailFit = fitWrappedTextMeasured(state.detail, usableW, detailBottom-detailTop, plateH*0.075, 8, "-apple-system,sans-serif", '500', 1.3);
        detailMarkup = renderWrappedBlock(detailFit.lines, detailFit.fontSize, 1.3, detailTop, detailBottom, '500', "-apple-system,sans-serif", 0.85, state.detailAlign);
        dividerMarkup = `<line x1="${cx-usableW*0.22}" y1="${dividerY}" x2="${cx+usableW*0.22}" y2="${dividerY}" stroke="${textColor}" stroke-width="1" opacity="0.4"/>`;
      }

      const iconSize = Math.min(usableH * (hasDetail ? 0.20 : 0.24), usableW*0.32);
      const iconMarkup = hasIcon
        ? `<g transform="translate(${cx-iconSize/2}, ${iconCy-iconSize/2}) scale(${iconSize/36})">${iconPath(state.icon, textColor)}</g>`
        : '';

      const content = `
        ${iconMarkup}
        ${headlineMarkup}
        ${dividerMarkup}
        ${detailMarkup}
      `;

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Informational sign preview">
          <defs>${defs}</defs>
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 8)}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          ${content}
        </svg>`;

      const stage = document.getElementById('is-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.ss-stage-caption'));
      }
      holder.innerHTML = svg;

      document.getElementById('is-stage-dims').textContent = `${size.w}" × ${size.h}" — Informational`;
      document.getElementById('is-stage-mount').textContent = MOUNTINGS[state.mounting].label;

      const textColorEl = root.querySelector('#is-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;
      const headlineEl = root.querySelector('#is-headline');
      if (headlineEl && document.activeElement !== headlineEl) headlineEl.value = state.headline;
      const detailEl = root.querySelector('#is-detail');
      if (detailEl && document.activeElement !== detailEl) detailEl.value = state.detail;

      buildChipRow(root.querySelector('#is-templateRow'), TEMPLATES, 'template');
      buildChipRow(root.querySelector('#is-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#is-adaRow'), ADA_MODES, 'adaMode');
      buildChipRow(root.querySelector('#is-typefaceRow'), TYPEFACES, 'typeface');
      buildChipRow(root.querySelector('#is-sizeRow'), SIZES, 'size');
      buildChipRow(root.querySelector('#is-mountingRow'), MOUNTINGS, 'mounting');
      buildChipRow(root.querySelector('#is-iconRow'), ICONS, 'icon', null, ()=>{ state.iconManual = true; });
      buildChipRow(root.querySelector('#is-detailModeRow'), DETAIL_MODES, 'detailMode');
      buildChipRow(root.querySelector('#is-headlineAlignRow'), ALIGNMENTS, 'headlineAlign');
      buildChipRow(root.querySelector('#is-detailAlignRow'), ALIGNMENTS, 'detailAlign');
      if (detailEl) detailEl.style.display = (state.detailMode==='with') ? '' : 'none';
      buildChipRow(root.querySelector('#is-accentRow'), ACCENTS, 'accent');
      const showAccentColor = ACCENTS[state.accent].needsColor;
      root.querySelector('#is-accentColorField').style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#is-accentColorRow'), ACCENT_COLORS, 'accentColor');
        root.querySelector('#is-accentCustomColorField').style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      // ---- compliance panel: contrast only — no forced typeface, no braille.
      // Informational/policy signs are exempt from §703.2/703.3 tactile
      // requirements; §703.5 (visual characters) is what actually applies. ----
      const complianceEl = root.querySelector('#is-complianceCheck');
      if (complianceEl){
        if (isAda){
          const ratio = contrastRatio(textColor, state.plateColor);
          const contrastPass = ratio >= 4.5;
          complianceEl.style.display = '';
          complianceEl.innerHTML = `
            <div class="ss-compliance-title">Visual Legibility Check</div>
            <div class="ss-compliance-row">${contrastPass ? '✓' : '⚠'} Contrast ratio ${ratio.toFixed(1)}:1 ${contrastPass ? '(strong contrast)' : '(pick a higher-contrast sign/text color pairing)'}</div>
            <div class="ss-compliance-row">ℹ Informational/policy signs are exempt from raised-character and braille requirements (§703.1 Exception 2) — unlike room ID signs, this one doesn't need either.</div>
            <div class="ss-compliance-note">§703.5 does require character height to scale with viewing distance for signs read from far away — this preview doesn't know your mounting distance, so confirm minimum character height with your fabricator for the specific install location. Non-glare finish is a physical fabrication property this preview can't verify. Not legal advice.</div>
          `;
        } else {
          complianceEl.style.display = 'none';
        }
      }

      buildChipRow(root.querySelector('#is-modeRow'), { single:{label:'Single Sign'}, bulk:{label:'Bulk Order'} }, 'mode', null, (newMode)=>{
        if (newMode==='bulk' && state.bulkOrders.length===0){
          const seedRow = {};
          PER_ROW_FIELDS.forEach(f=>{ seedRow[f] = state[f]; });
          seedRow.quantity = 1;
          state.bulkOrders.push(seedRow);
          state.activeBulkIndex = 0;
        }
      });
      const bulkSection = root.querySelector('#is-bulkSection');
      if (bulkSection) bulkSection.style.display = (state.mode==='bulk') ? '' : 'none';
      if (state.mode==='bulk') buildOrdersTable(root.querySelector('#is-ordersTable'));

      const priceEl = document.getElementById('is-priceValue');
      const unavailableEl = document.getElementById('is-unavailable');
      const addBtn = document.getElementById('is-addBtn');

      if (state.mode==='bulk'){
        const { total, prefix, anyMissing, validCount } = computeBulkTotal();
        priceEl.textContent = validCount ? `${prefix}${total.toFixed(2)}` : '—';
        if (!state.bulkOrders.length){
          unavailableEl.textContent = 'Add at least one sign to this order first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (validCount === 0){
          unavailableEl.textContent = 'Add headline text to at least one sign in this order.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (anyMissing){
          unavailableEl.textContent = 'This size/mounting combination isn\u2019t available — try a different size or mounting.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
        addBtn.textContent = `Add All to Cart (${validCount})`;
      } else {
        const variant = findVariant();
        if (variant){
          priceEl.textContent = variant.price;
          if (!variant.available){
            unavailableEl.textContent = 'This combination is currently out of stock.';
            unavailableEl.style.display = '';
            addBtn.disabled = true;
          } else if (!state.headline.trim()){
            unavailableEl.textContent = 'Add headline text first.';
            unavailableEl.style.display = '';
            addBtn.disabled = true;
          } else {
            unavailableEl.style.display = 'none';
            addBtn.disabled = false;
          }
        } else {
          priceEl.textContent = '—';
          unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        }
        addBtn.textContent = 'Add to cart';
      }

      if (state.mode==='bulk' && state.bulkOrders[state.activeBulkIndex]){
        saveActiveRowFromState();
      }
    }

    function buildSharedProperties(){
      const properties = {
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label,
        'Shape Color': state.plateColor,
        'Text Color': state.textColor
      };
      if (state.adaMode==='on') properties['ADA Visual Compliance'] = 'Checked — contrast verified, confirm char height for install distance';
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }
      return properties;
    }
    function buildRowProperties(row){
      const properties = Object.assign({
        'Template': TEMPLATES[row.template].label,
        'Headline': row.headline
      }, buildSharedProperties());
      if (row.detailMode==='with' && row.detail.trim()) properties['Detail'] = row.detail;
      if (row.icon!=='none') properties['Icon'] = ICONS[row.icon].label;
      return properties;
    }

    function addToCart(){
      const errorEl = document.getElementById('is-error');
      const addBtn = document.getElementById('is-addBtn');

      let items;
      if (state.mode==='bulk'){
        saveActiveRowFromState();
        const validRows = state.bulkOrders.filter(r=>r.headline.trim() && r.quantity>0);
        if (!validRows.length) return;
        const variant = findVariant();
        if (!variant || !variant.available) return;
        items = validRows.map(row=>({ id: variant.id, quantity: row.quantity, properties: buildRowProperties(row) }));
      } else {
        const variant = findVariant();
        if (!variant || !variant.available || !state.headline.trim()) return;
        items = [{ id: variant.id, quantity: 1, properties: buildRowProperties(state) }];
      }

      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = (state.mode==='bulk') ? `Added ${items.length} ✓` : 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        if (state.mode==='bulk'){
          state.bulkOrders = [];
          state.activeBulkIndex = 0;
        }
        setTimeout(()=>{ addBtn.classList.remove('ss-added'); render(); }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#is-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    bindBulkControls();
    render();
  }
})();
